/**
 * Deeplink Handler
 * Verarbeitet URL-Parameter wie ?msg=<messageId>
 * Führt Login durch falls nötig, dann öffnet Nachricht im Modal
 */

(function () {
  'use strict';

  // Hilfsfunktion: URL-Parameter auslesen
  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }

  // Hilfsfunktion: URL-Parameter entfernen (nach Verarbeitung)
  function removeQueryParam(name) {
    const url = new URL(window.location)
    url.searchParams.delete(name)
    window.history.replaceState({}, '', url)
  }

  // Prüfen ob User eingeloggt ist
  function isLoggedIn() {
    return !!localStorage.getItem('token')
  }

  // Deeplink-Parameter speichern und zum Login weiterleiten
  function saveDeeplinkAndRedirectToLogin(param, value) {
    sessionStorage.setItem('deeplink_' + param, value)
    sessionStorage.setItem('deeplink_returnUrl', window.location.pathname)
    window.location.href = '/index.html'
  }

  // Nachricht im Modal öffnen
  function openMessageModal(messageId) {

    // Modal öffnen
    const modal = new bootstrap.Modal(document.getElementById('messageDetail'))
    modal.show()

    // Loading-Anzeige
    $('#messageDetailContent').html('<div class="text-center p-5"><i class="fa fa-spinner fa-spin fa-3x"></i><p class="mt-3">Nachricht wird geladen...</p></div>')

    // Nachricht laden (nutzt bestehende Funktion aus shared.js)
    getMessageDetail(messageId)
      .then(function(html) {
        $('#messageDetailContent').html(html)
      })
      .catch(function(err) {
        $('#messageDetailContent').html('<div class="alert alert-danger m-3">Fehler beim Laden der Nachricht: ' + err.message + '</div>')
      })
  }

  // Beim Laden: Deeplink-Parameter prüfen
  $(document).ready(function () {
    
    // Fall 1: Auf Login-Seite und Deeplink vorhanden
    if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
      const msg = getQueryParam('msg')
      
      if (msg) {
        // Deeplink speichern für nach dem Login
        sessionStorage.setItem('deeplink_msg', msg)
        console.log('Deeplink: msg Parameter gespeichert:', msg)
      }
    }
    
    // Fall 2: Auf gesicherter Seite - Deeplink aus sessionStorage verarbeiten
    if (window.location.pathname.startsWith('/secure/user/')) {
      const deeplinkMsg = sessionStorage.getItem('deeplink_msg')
      
      if (deeplinkMsg) {
        console.log('Deeplink: Verarbeite msg:', deeplinkMsg)
        
        // Kurz warten damit Seite vollständig geladen ist
        setTimeout(function() {
          openMessageModal(deeplinkMsg)
          
          // Deeplink aus sessionStorage entfernen (einmalig)
          sessionStorage.removeItem('deeplink_msg')
          sessionStorage.removeItem('deeplink_returnUrl')
        }, 500)
      }
    }
    
    // Fall 3: Auf gesicherter Seite mit direktem ?msg Parameter
    if (window.location.pathname.startsWith('/secure/user/')) {
      const msg = getQueryParam('msg')
      
      if (msg && isLoggedIn()) {
        console.log('Deeplink: Direkter msg Parameter:', msg)
        
        setTimeout(function() {
          openMessageModal(msg)
          
          // Parameter aus URL entfernen
          removeQueryParam('msg')
        }, 500)
      } else if (msg && !isLoggedIn()) {
        // Nicht eingeloggt → zum Login mit Parameter
        saveDeeplinkAndRedirectToLogin('msg', msg)
      }
    }
  })

})()
